import * as Sentry from '@sentry/vue'
import {ProductTourType} from '@toolify/server/src/enum/ProductTourType'
import {UserSettingName} from '@toolify/server/src/models/mongoose/UserModel/enum/UserSettingName'
import {
  IProductTourState,
  IProductTourStateEntry,
} from '@toolify/server/src/services/UserSettingsService/strategies/ProductTourStateUserSettingStrategy/types/IProductTourStateUserSettingStrategyInterfaces'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {useMeApiStore} from '@toolify/client/src/stores/api/MeApiStore/useMeApiStore'

export function getProductTourState(): IProductTourState {
  const authStore = useAuthStore()
  return authStore.currentUser?.settings?.[UserSettingName.ProductTourState] ?? {}
}

export async function persistProductTourState(tourType: ProductTourType, entry: IProductTourStateEntry): Promise<void> {
  const authStore = useAuthStore()
  const meApiStore = useMeApiStore()
  const nextState: IProductTourState = {
    ...getProductTourState(),
    [tourType]: entry,
  }
  try {
    await meApiStore.updateSetting(UserSettingName.ProductTourState, nextState)
    await authStore.refetchCurrentEntity()
  } catch (error) {
    Sentry.captureException(error)
  }
}
